import { render } from "./ActivityDetailPanelContentLoadingState.vue?vue&type=template&id=ef180546&scoped=true"
const script = {}

import "./ActivityDetailPanelContentLoadingState.vue?vue&type=style&index=0&id=ef180546&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef180546"]])

export default __exports__